module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/16.c4fa227a.png";